import ajax from '../utils/ajax';

/** @typedef {import("./types").Address} Address */
/** @typedef {import("./types").AddressInputs} AddressInputs */


class VerifyAddressResponse {
  constructor(apiResponseData, requestedCountryValue) {
    const { ShowSuggestedAddressMsg, NoSuggestedAddressMsg, SuggestedAddresses } = apiResponseData;

    this.verificationFailed =
        (ShowSuggestedAddressMsg && NoSuggestedAddressMsg !== null) ||
        SuggestedAddresses.length === 0;

    // Modify suggested address data to include requestedCountryCode
    this.suggestedAddresses = SuggestedAddresses
      .map(address => Object.assign({}, address, { requestedCountryValue }));
  }
}


/**
 * @param {Address} address
 */
async function verifyAddress(address) {
  const requestedCountryValue = address.countryId;

  const response = await ajax.post('/_service/Verification.asmx/Verify', {
    request: {
      Street1: address.address1,
      Street2: address.address2,
      City: address.city,
      Country: address.countryId,
      PostalCode: address.postalCode,
      State: address.state,
    },
  });

  return new VerifyAddressResponse(response.d.Data, requestedCountryValue);
}


/**
 * @param {string} countryId
 * @param {string} addressId
 * @returns {Address}
 */
async function getAddress(countryId, addressId) {
  const data = {
    Country: '0',
    Id: addressId,
  };

  const response = await ajax.post('/_service/Verification.asmx/GetAddress', { request: data });

  const returnedAddress = response.d.Data.FormattedAddress;

  return {
    address1: returnedAddress.Street1,
    address2: returnedAddress.Street2,
    city: returnedAddress.City,
    state: returnedAddress.State,
    postalCode: returnedAddress.PostalCode,
    countryId,
  };
}

/**
 * @param {Address} address
 * @returns {Array}
 */
async function getSuggestedAddresses(address) {
  try {
    const verifyResponse = await verifyAddress(address);

    if (!verifyResponse.verificationFailed) {
      return verifyResponse.suggestedAddresses;
    }
  } catch (error) {
  }

  return [];
}


export default {
  getAddress,
  getSuggestedAddresses,
};



// WEBPACK FOOTER //
// ./V7/addressVerification/AddressVerificationService.js